import { useMutation } from 'react-query';

import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { UserProductTypes } from '@/types';

import { ResponseError } from '..';
export type ReactivateUserPendingProductProps = {
  mdirectorId: string;
  onErrorCallback: ({ status, detail }: ResponseError, mdirectorId: string) => void;
};

export const reactivateUserCancelledProduct = ({
  mdirectorId,
  onErrorCallback,
}: ReactivateUserPendingProductProps): Promise<UserProductTypes[]> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'my-products/' + mdirectorId;
  return axios
    .patch(endPoint)
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      const status = error.response.status;
      const detail = error.response.data.detail;
      onErrorCallback && onErrorCallback({ status, detail }, mdirectorId);
    });
};

type UseReactivateUserCancelledProductOptions = {
  config?: MutationConfig<typeof reactivateUserCancelledProduct>;
};

export const useReactivateUserCancelledProduct = ({
  config,
}: UseReactivateUserCancelledProductOptions = {}) => {
  return useMutation({
    onMutate: async (creatingNotification: any) => {
      await queryClient.cancelQueries(['my-products', creatingNotification]);

      const previousDetails = queryClient.getQueryData<UserProductTypes>([
        'my-products',
        creatingNotification,
      ]);

      queryClient.setQueryData(['my-products', creatingNotification], {
        ...previousDetails,
        ...creatingNotification.data,
      });

      return { previousDetails: previousDetails };
    },
    onError: (_, __, context: any) => {
      if (context?.previousDetails) {
        queryClient.setQueryData(['my-products', context.previousDetails], context.previousDetails);
      }
    },
    onSuccess: (data) => {
      return queryClient.refetchQueries(['my-products', data]);
    },
    ...config,
    mutationFn: reactivateUserCancelledProduct,
  });
};
